<footer class="sticky-footer bg-white mt-5 pt-3">
  <div class="container-fluid my-auto row">
    <div class="col-md-6 pb-3">
      <div class="copyright">
        <span>Copyright &copy;2025 Klear.ai</span>
      </div>
    </div>
    <div class="col-md-6 text-right">
      <div style="float: inline-end; font-size: 0.8rem;
      font-weight: 600; color: #041F55; width: 25%;">{{ currentDateAndTime }}</div>
    </div>
  </div>
</footer>

